<div class="rd-widget rd-widget-no-height-restriction cellspacing-0 cellpadding-0" numberoflines=""  *ngIf="widgetData">
  <div class="table-part">
    <table aria-hidden="true">
      <thead>
        <tr class="red-line">
          <th scope="col" colspan="5">{{'capitalExpenditures.capitalExpendituresSummary' | rdTranslate}}</th>
          <th scope="col" colspan="2">{{widgetData.years.length}} {{'capitalExpenditures.yearTotal' | rdTranslate}}</th>
          <th scope="col" *ngFor="let yearData of widgetData.years; let i = index"><widget-value [align]="'right'" [color]="'white'">{{'capitalExpenditures.year' | rdTranslate}} {{i + 1}}</widget-value></th>
        </tr>
        <tr class="red-line">
          <th scope="col" colspan="5">&nbsp;</th>
          <th scope="col" colspan="2">&nbsp;</th>
          <th scope="col" *ngFor="let yearData of widgetData.years; let i = index"><widget-value [align]="'right'" [color]="'white'">{{yearData.periodDescription}}</widget-value></th>
        </tr>
      </thead>
      <ng-container *ngFor="let row of widgetData.rows; let i = index">
        <tr [ngClass]="{'total-line': row.isTotal, 'last': i === widgetData.rows.length -1}" class="white-line">
          <td colspan="5"><widget-label [widget]="this" [fieldName]="row.label" [align]="'left'" [bold]="row.isTotal"></widget-label></td>
          <td colspan="2" class="light-grey-column"><widget-value [align]="'right'" [bold]="row.isTotal">{{(row.yearTotal || 0) | rdLocalizedNumber:0}}</widget-value></td>
          <td *ngFor="let data of row.entries; let i = index"><widget-value [align]="'right'" [bold]="row.isTotal">{{(data || 0) | rdLocalizedNumber:0}}</widget-value></td>
        </tr>
      </ng-container>
      <tr>
        <td>&nbsp;</td>
      </tr>
    </table>
    <table aria-hidden="true">
      <thead>
        <tr>
          <th scope="col" colspan="18">&nbsp;</th>
        </tr>
      </thead>
      <tr>
        <td colspan="8">
          <div class="k-donut-chart-container-print-fix" style="height: 380px; width:430px;">
            <kendo-chart class="k-donut-chart-area" *ngIf="chartsReady" [transitions]="chartTransitionsEnabled">
              <kendo-chart-title text="{{'capitalExpenditures.capitalExpenditures' | rdTranslate}}" font="16px Arial"></kendo-chart-title>
              <kendo-chart-area background="white" height="300" width="487"></kendo-chart-area>
              <kendo-chart-value-axis>
                <kendo-chart-value-axis-item name="first">
                  <kendo-chart-value-axis-item-title font="12px Arial"></kendo-chart-value-axis-item-title>
                  <kendo-chart-value-axis-item-labels font="12px Arial"></kendo-chart-value-axis-item-labels>
                </kendo-chart-value-axis-item>
              </kendo-chart-value-axis>
              <kendo-chart-category-axis>
                <kendo-chart-axis-defaults>
                  <kendo-chart-axis-defaults-labels format="n0">
                  </kendo-chart-axis-defaults-labels>
                </kendo-chart-axis-defaults>
                <kendo-chart-category-axis-item [categories]="categories">
                  <kendo-chart-category-axis-item-labels font="12px Arial"></kendo-chart-category-axis-item-labels>
                </kendo-chart-category-axis-item>
              </kendo-chart-category-axis>
              <kendo-chart-series>
                <kendo-chart-series-item *ngFor="let item of columnChartData; let i = index;" type="column" [name]="item.name" [color]="item.color" [stack]="true" [gap]="1"
                                         [data]="item.data" axis="first">
                </kendo-chart-series-item>
              </kendo-chart-series>
              <kendo-chart-legend [visible]="true" [labels]="{color: '#000000', font: '12px Arial'}" position="bottom" orientation="horizontal">
              </kendo-chart-legend>
            </kendo-chart>
          </div>
        </td>
        <td colspan="2">&nbsp;</td>
        <td colspan="8">
          <div class="k-donut-chart-container-print-fix" style="height: 380px; width:430px;">
            <kendo-chart class="k-donut-chart-area" *ngIf="chartsReady" [transitions]="chartTransitionsEnabled">
              <kendo-chart-title text="{{'capitalExpenditures.capitalExpenditures' | rdTranslate}}" font="16px Arial"></kendo-chart-title>
              <kendo-chart-area background="white" height="300" width="487"></kendo-chart-area>
              <ng-template kendoChartDonutCenterTemplate>
              </ng-template>
              <kendo-chart-series>
                <kendo-chart-series-item type="donut" [data]="pieChartData" categoryField="label" field="value" [size]="(donutHoleScale*75)" [holeSize]="(donutHoleScale*35)" [autoFit]="false">
                  <kendo-chart-series-item-labels position="center"
                                                  color="#ffffff"
                                                  font="normal normal 700 12px Arial"
                                                  background="none"
                                                  margin="5"
                                                  [content]="chartLabelContent">
                  </kendo-chart-series-item-labels>
                </kendo-chart-series-item>
              </kendo-chart-series>

              <kendo-chart-legend [visible]="true" [position]="'bottom'" [labels]="{color: '#000000', font: '12px Arial'}" orientation="horizontal">
              </kendo-chart-legend>
            </kendo-chart>
          </div>
        </td>
      </tr>
    </table>
  </div>
</div>
